import PaymentCycleConfigurationsResource from "./paymentCycleConfigurations.resource";

const paymentCycleConfigurationsModule = angular
  .module("app.resources.paymentCycleConfigurations", [])
  .service("PaymentCycleConfigurations", PaymentCycleConfigurationsResource);

export default paymentCycleConfigurationsModule;



// WEBPACK FOOTER //
// ./src/resources/paymentCycleConfigurations/paymentCycleConfigurations.module.js